/**
 * Действует ли в партии досрочный конец «в живых один» (см.
 * findLastStandingPlayer, GAME_END_REASONS.LAST_PLAYER_STANDING).
 *
 * Записи матчей проигрываются через редьюсеры: партия, сыгранная до правила,
 * при нем закончилась бы раньше, чем на самом деле, и остаток записи разошелся
 * бы с сыгранным. Флаг isLastStandingEndRule ставит LOAD_STATE (см. loadState в
 * redux/actions); у старых записей его нет — только у них он false.
 *
 * @param {Object} [gameState] - состояние партии
 * @returns {boolean}
 */
export const checkIfLastStandingEndRule = (gameState) => gameState?.isLastStandingEndRule !== false;
